"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBox = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Props_1 = require("../../shared/Props");
const Responsive_1 = require("../../shared/Responsive");
const getBackgroundColor = ({ $backgroundColor, }) => {
    if (!$backgroundColor)
        return "transparent";
    if ((0, Props_1.isGreyscaleColor)($backgroundColor)) {
        return `var(--ds-color-${$backgroundColor})`;
    }
    return `var(--ds-color-${$backgroundColor}-10)`;
};
const StyledBox = styled_components_1.default.div `
    ${({ $display }) => {
    return $display && (0, Responsive_1.responsiveCssToMedia)($display, "display");
}}

    background-color: ${getBackgroundColor};

    ${({ $position }) => $position && (0, Responsive_1.responsiveCssToMedia)($position, "position")};

    ${({ $top }) => {
    return $top && (0, Responsive_1.responsiveCssToMedia)($top, "top");
}}

    ${({ $right }) => {
    return $right && (0, Responsive_1.responsiveCssToMedia)($right, "right");
}}
    
    ${({ $bottom }) => {
    return $bottom && (0, Responsive_1.responsiveCssToMedia)($bottom, "bottom");
}}
    
    ${({ $left }) => {
    return $left && (0, Responsive_1.responsiveCssToMedia)($left, "left");
}}

    ${({ $width }) => $width && (0, Responsive_1.responsiveCssToMedia)($width, "width")};

    ${({ $minWidth }) => $minWidth && (0, Responsive_1.responsiveCssToMedia)($minWidth, "min-width")};

    ${({ $maxWidth }) => $maxWidth && (0, Responsive_1.responsiveCssToMedia)($maxWidth, "max-width")};

    ${({ $height }) => $height && (0, Responsive_1.responsiveCssToMedia)($height, "height")};

    ${({ $minHeight }) => $minHeight && (0, Responsive_1.responsiveCssToMedia)($minHeight, "min-height")};

    ${({ $maxHeight }) => $maxHeight && (0, Responsive_1.responsiveCssToMedia)($maxHeight, "max-height")};

    ${({ $overflow }) => $overflow && (0, Responsive_1.responsiveCssToMedia)($overflow, "overflow")};

    ${({ $overflowX }) => $overflowX && (0, Responsive_1.responsiveCssToMedia)($overflowX, "overflow-x")};

    ${({ $overflowY }) => $overflowY && (0, Responsive_1.responsiveCssToMedia)($overflowY, "overflow-y")};

    ${({ $p }) => {
    return $p && (0, Responsive_1.responsiveCssToMedia)($p, "padding");
}}

    ${({ $px }) => {
    return $px && (0, Responsive_1.responsiveCssToMedia)($px, "padding-right");
}}

    ${({ $px }) => {
    return $px && (0, Responsive_1.responsiveCssToMedia)($px, "padding-left");
}}

    ${({ $py }) => {
    return $py && (0, Responsive_1.responsiveCssToMedia)($py, "padding-top");
}}

    ${({ $py }) => {
    return $py && (0, Responsive_1.responsiveCssToMedia)($py, "padding-bottom");
}}
    
    ${({ $pt }) => {
    return $pt && (0, Responsive_1.responsiveCssToMedia)($pt, "padding-top");
}}
    
    ${({ $pr }) => {
    return $pr && (0, Responsive_1.responsiveCssToMedia)($pr, "padding-right");
}}
    
    ${({ $pb }) => {
    return $pb && (0, Responsive_1.responsiveCssToMedia)($pb, "padding-bottom");
}}
    
    ${({ $pl }) => {
    return $pl && (0, Responsive_1.responsiveCssToMedia)($pl, "padding-left");
}}
    
    ${({ $m }) => {
    return $m && (0, Responsive_1.responsiveCssToMedia)($m, "margin");
}}

    ${({ $mx }) => {
    return $mx && (0, Responsive_1.responsiveCssToMedia)($mx, "margin-right");
}}

    ${({ $mx }) => {
    return $mx && (0, Responsive_1.responsiveCssToMedia)($mx, "margin-left");
}}

    ${({ $my }) => {
    return $my && (0, Responsive_1.responsiveCssToMedia)($my, "margin-top");
}}

    ${({ $my }) => {
    return $my && (0, Responsive_1.responsiveCssToMedia)($my, "margin-bottom");
}}

    ${({ $mt }) => {
    return $mt && (0, Responsive_1.responsiveCssToMedia)($mt, "margin-top");
}}
    
    ${({ $mr }) => {
    return $mr && (0, Responsive_1.responsiveCssToMedia)($mr, "margin-right");
}}
    
    ${({ $mb }) => {
    return $mb && (0, Responsive_1.responsiveCssToMedia)($mb, "margin-bottom");
}}
    
    
    ${({ $ml }) => {
    return $ml && (0, Responsive_1.responsiveCssToMedia)($ml, "margin-left");
}}
`;
exports.StyledBox = StyledBox;
//# sourceMappingURL=Box.styles.js.map